import React, { Component, Fragment } from 'react'
import {connect} from "react-redux";
import Loader from "../../components/Loader";
import {hideModal} from "src/actions/modal.actions";
import {clearReleaseNotes, getReleaseNotes} from "src/actions/domain.actions";
import {toastr} from "react-redux-toastr";

class ReleaseNotesModal extends Component {

    componentDidMount() {
        const {getReleaseNotes, modalProps} = this.props
        getReleaseNotes(modalProps.releaseVersion)
        localStorage.setItem("ReleaseNotesReminderSet", "false")
        localStorage.setItem("ReleaseNotesViewedSinceLogin", "true")
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { releaseNotes } = this.props

        if(releaseNotes.error) {
            toastr.error(releaseNotes.error, {timeOut: 5000, position: 'top-center'});
        }
    }

    componentWillUnmount() {
        const {clearReleaseNotes} = this.props
        clearReleaseNotes()
    }


    render() {
        const {releaseNotes, hideModal} = this.props

            return (
                <Fragment>
                    <div className="release-notes-modal" style={{display: 'block', height:'100%'}} tabIndex="-1"
                         role="dialog">
                        <div className="modal-dialog" style={{minHeight:'70vh'}}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Release Notes
                                    </h5>
                                    <button onClick={this.props.hideModal} type="button" className="close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{padding: '0rem 1rem'}}>
                                    {releaseNotes.data && !releaseNotes.error ?
                                        <iframe height={'70vh'} width={'70vw'} srcDoc={releaseNotes.data}  />
                                        :
                                        <Loader />
                                    }
                                </div>
                                <div className="modal-footer">
                                    <button onClick={hideModal} className="btn" type="button">
                                        Cancel
                                    </button>
                                    <button onClick={() => {
                                        localStorage.setItem("ReleaseNotesReminderSet", "true")
                                        hideModal()
                                        }
                                    }
                                            className="btn btn-primary" type="button">
                                        Remind me later
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop show" tabIndex="1"/>
                </Fragment>
            )
    }
}

const mapStateToProps = (state) => {
    const releaseNotes = state.domain.releaseNotes;
    const modalProps = state.modals.modalProps;

    return {
        releaseNotes,
        modalProps
    };
};

const mapDispatchToProps = {
    hideModal,
    getReleaseNotes,
    clearReleaseNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseNotesModal);
